import { render, staticRenderFns } from "./SelectValidationType.vue?vue&type=template&id=0e1c74cf&lang=pug"
import script from "./SelectValidationType.vue?vue&type=script&lang=js"
export * from "./SelectValidationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports